import brokerTypes from '../constants/BrokerTypes';

export function isBrokerKey(value) {
    return brokerTypes.some((broker) => broker.key === value);
}

export function getBrokerOptions() {
    return brokerTypes.filter((broker) => broker.key !== 'OUTRA');
}

export function getBrokerLabel(value, t) {
    if (!value) {
        return t('bank_not_found');
    }

    const broker = brokerTypes.find((item) => item.key === value);

    return broker ? broker.value : value;
}

export function getBrokerInputValue(value, t) {
    if (!value) {
        return '';
    }

    return getBrokerLabel(value, t);
}

export function normalizeBrokerValue(value) {
    if (!value) {
        return '';
    }

    const normalizedValue = value.trim().toLowerCase();
    const broker = getBrokerOptions().find((item) =>
        item.value.trim().toLowerCase() === normalizedValue || item.key.trim().toLowerCase() === normalizedValue
    );

    return broker ? broker.key : value.trim();
}
